import { render } from "./Publish.vue?vue&type=template&id=9ddad386"
import script from "./Publish.vue?vue&type=script&setup=true&lang=js"
export * from "./Publish.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Results/Publish.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9ddad386"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9ddad386', __exports__)) {
    api.reload('9ddad386', __exports__)
  }
  
  module.hot.accept("./Publish.vue?vue&type=template&id=9ddad386", () => {
    api.rerender('9ddad386', render)
  })

}


export default __exports__